import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ShoppingBag } from "react-feather";
import clsx from "clsx";
import PageHeader from "@/components/PageHeader";
import Button from "@/components/Button";
import api from "../api";
import { useGlobalData } from "../context/globalContext";
import { getPaymentGatewayId } from "../reducers/utils";

export default function OrderConfirmationPage() {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [statusData, setStatusData] = useState(null);
  const [order,setOrderData] = useState()
  const queryParams = new URLSearchParams(location.search);
  const paymentId = queryParams.get("payment_id");
  const txnOrderId = queryParams.get("txnOrder_id");
  const orderId = queryParams.get("order_id");
  const orderTotal = queryParams.get("order_total");
  const  websiteDetails  = useGlobalData();
  const webDetails = websiteDetails.websiteDetails

  useEffect(() => {
    if (!orderId) return;
    const fetchStatus = async () => {
      const orderData = await api.fetchOrderDetails(orderId);
      // console.log("fetched order",orderData.order)
          setOrderData(orderData.order);
      if (orderData.order?.paymentMethod == "cod") {
        setStatusData({
          order_id: orderData.order.order_id,
          payment_orderId: "N/A",
          status: "COD",
          currency: "INR",
          amount: orderData.order.amount.toFixed(2),
          total: orderData.order.amount.toFixed(2),
          paymentType: "COD",
          paymentMethod: "Cash on Delivery",
          txn_uuid: "N/A",
          txnDate: new Date(orderData.order.createdAt).toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
          }),
        });
        setLoading(false);
        return;
      }

      try {
        const res = await api.razorpayPaymentStatus(paymentId,txnOrderId,orderId,orderTotal,getPaymentGatewayId(webDetails?.pg_gateways));
        // console.log(res.data)
        const paidAmount = res.data.amount / 100;
        setStatusData({
          order_id: orderData.order.order_id,
          payment_orderId: res.data.order_id,
          status:
            paidAmount === Number(orderTotal)
              ? res.data.status
              : "Failed (Amount Mismatch)",
          currency: res.data.currency || "INR",
          amount: paidAmount,
          total: orderTotal,
          paymentType: res.data.paymentType || res.data.selectedPayment,
          paymentMethod: res.data.method || "N/A",
          txn_uuid: res.data.id || "N/A",
          txnDate: new Date(res.data.created_at * 1000).toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
          }),
        });

        const receipt =  await api.adcReceipt(orderId,getPaymentGatewayId(webDetails?.pg_gateways));
        // console.log("receipt response",receipt);

      } catch (err) {
        console.error("Error fetching payment status:", err);
        setStatusData({
          order_id: res.order.order_id,
          status: "Payment not completed",
          currency: "INR",
          amount: orderData.order.amount.toFixed(2),
          total: orderData.order.amount.toFixed(2),
          paymentType: orderData.order.paymentMethod,
          paymentMethod: "N/A",
          txn_uuid: "N/A",
         txnDate: new Date(orderData.order.createdAt).toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
          }),
        });
      } finally {
        setLoading(false);
        await api.clearCart();
      }
    };

    fetchStatus();
  }, [orderId, paymentId, txnOrderId, orderTotal]);

  if (loading) {
    return (
      <main className="min-h-screen flex items-center justify-center">
        <p className="text-gray-600">Fetching payment details...</p>
      </main>
    );
  }

  if (!statusData) {
    return (
      <main className="min-h-screen flex flex-col items-center text-center my-14 space-y-4">
        <PageHeader>No Order Found</PageHeader>
        <Link to="/products">
          <Button link>
            <ShoppingBag className="mr-2" />
            Shop Now
          </Button>
        </Link>
      </main>
    );
  }

  return (
    <main className="min-h-screen my-14 px-4">
      <PageHeader>Payment Confirmation</PageHeader>

      {/* PAYMENT DETAILS CONTAINER */}
      <section
        className={clsx(
          "max-w-xl mx-auto mt-10",
          "border border-gray-300 rounded-lg",
          "shadow bg-white p-6 space-y-4"
        )}
      >
        <Detail label="Order ID" value={statusData.order_id} />
        {order?.paymentMethod === "cod"
        ?<></>:
        <Detail label="Payment Order ID" value={statusData.payment_orderId} />
        }
        {order.paymentMethod === "cod"
        ?<></>:
        <Detail label="Transaction ID" value={statusData.txn_uuid} />
        }
        <Detail label="Status" value={statusData.status} highlight />
        <Detail label="Amount Paid" value={`₹ ${statusData.amount}`} />
        {/* <Detail label="Total Amount" value={`₹ ${statusData.total}`} /> */}
        {/* <Detail label="Payment Type" value={statusData.paymentType} /> */}
        <Detail label="Payment Method" value={statusData.paymentMethod} />
        <Detail label="Date" value={statusData.txnDate} />
      </section>
    </main>
  );
}

function Detail({ label, value, highlight }) {
  return (
    <div className="flex justify-between text-sm">
      <span className="text-gray-600">{label}</span>
      <span
        className={clsx(
          "font-medium",
          highlight && "text-green-600 font-semibold"
        )}
      >
        {value}
      </span>
    </div>
  );
}
